/* Alatreyu Haptics — tactile feedback for mobile interactions.
   Android: navigator.vibrate() (Chrome, Samsung Internet).
   iOS: toggles a hidden <label><input switch></label> (Safari 17.4+).
   Gated behind prefers-reduced-motion for accessibility. */

(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isTouchDevice = window.matchMedia('(pointer: coarse)').matches;

  function haptic(pattern) {
    if (reducedMotion) return;
    pattern = pattern || 'tap';

    /* Android / browsers with Vibration API.
       Guard behind userActivation to avoid console errors in headless/Lighthouse. */
    if (navigator.vibrate && navigator.userActivation && navigator.userActivation.hasBeenActive) {
      if (pattern === 'tap') navigator.vibrate(50);
      else if (pattern === 'success') navigator.vibrate([50, 70, 50]);
      else if (pattern === 'error') navigator.vibrate([50, 70, 50, 70, 50]);
      else if (pattern === 'reveal') navigator.vibrate([50, 40, 30, 40, 15]);
      return;
    }

    /* iOS Safari — checkbox switch hack (requires label wrapper) */
    if (!isTouchDevice) return;
    iosTap();
    if (pattern === 'success') setTimeout(iosTap, 120);
    if (pattern === 'error') { setTimeout(iosTap, 120); setTimeout(iosTap, 240); }
    if (pattern === 'reveal') { setTimeout(iosTap, 100); setTimeout(iosTap, 220); }
  }

  function iosTap() {
    try {
      var label = document.createElement('label');
      label.style.display = 'none';
      var input = document.createElement('input');
      input.type = 'checkbox';
      input.setAttribute('switch', '');
      label.appendChild(input);
      document.head.appendChild(label);
      label.click();
      document.head.removeChild(label);
    } catch (e) { /* silent */ }
  }

  window.AlatreyuHaptics = haptic;
})();
